import { alignIfLegacy } from '../utils.js';
import { WIX_PROTOCOL } from '../constants.js';
export function transformSDKImageToRESTImage(val) {
    if (!val) {
        return;
    }
    const alignedImage = alignIfLegacy(val, 'image');
    const { protocol, hash, pathname } = new URL(alignedImage);
    const params = new URLSearchParams(hash.replace('#', ''));
    const height = params.get('originHeight');
    const width = params.get('originWidth');
    const [id, filenameOrAltText] = pathname
        .replace(`image://v1/`, '')
        .split('/');
    const decodedFilenameOrAltText = decodeURIComponent(filenameOrAltText);
    if (protocol === WIX_PROTOCOL) {
        const res = { id, height: Number(height), width: Number(width) };
        if (!decodedFilenameOrAltText) {
            return res;
        }
        return {
            ...res,
            altText: decodedFilenameOrAltText,
            filename: decodedFilenameOrAltText,
            url: val,
        };
    }
    return { url: val };
}
export function transformRESTImageToSDKImage(payload) {
    if (!payload) {
        return;
    }
    let fileNameOrAltText = '';
    if (payload.filename || payload.altText) {
        fileNameOrAltText = `/${encodeURIComponent((payload.filename || payload.altText))}`;
    }
    return payload.id
        ? `wix:image://v1/${payload.id}${fileNameOrAltText}#originWidth=${payload.width}&originHeight=${payload.height}`
        : payload.url;
}
